import { render, staticRenderFns } from "./accountManagement.vue?vue&type=template&id=06b12bda&scoped=true&"
import script from "./accountManagement.vue?vue&type=script&lang=js&"
export * from "./accountManagement.vue?vue&type=script&lang=js&"
import style0 from "./accountManagement.vue?vue&type=style&index=0&id=06b12bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b12bda",
  null
  
)

export default component.exports